import { render, staticRenderFns } from "./FaultAlarm.vue?vue&type=template&id=54802d1d&scoped=true"
import script from "./FaultAlarm.vue?vue&type=script&lang=js"
export * from "./FaultAlarm.vue?vue&type=script&lang=js"
import style0 from "./FaultAlarm.vue?vue&type=style&index=0&id=54802d1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54802d1d",
  null
  
)

export default component.exports